import { Component, OnInit, Input } from '@angular/core';
import { AlertController, LoadingController, ModalController } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-bom-auto-mapping',
  templateUrl: './bom-auto-mapping.component.html',
  styleUrls: ['./bom-auto-mapping.component.scss'],
})
export class BomAutoMappingComponent implements OnInit {
  @Input() autoMapData : any;
  @Input() userMail : any;

  autoMapfieldsData : any;
  loadingView: any;
  addedRowsCount = 0;
  mainRowArrayObj = {
    'labelsArray' : [],
    'bomOneMapArrayData' : [],
    'bomTwoMapArrayData' : []
  };
  
  bomMapPopoverOptions: any = {  
    cssClass: 'bom-popup-mapping'
  }; 
  constructor(public apiservice: ApiService,public alertController: AlertController, public loadingController: LoadingController,private modelController:ModalController) {
    
  }

  ngOnInit() {
      setTimeout(() =>{
        this.autoMapfieldsData = this.autoMapData
        for(var dataIndx in this.autoMapfieldsData['headerDataValuesBOM1']['custmerFileColumnheaderMapIndex']){
          var displayName = dataIndx == 'item_num'?'Item Number':dataIndx == 'quantity'?'Quantity':dataIndx == 'reference_designators'?'Reference designator': dataIndx == 'manufacturer_part_number'?'MPN': dataIndx == 'manufacturer'?'Manufacturer':dataIndx == 'description'?'Description':dataIndx == 'value' ? 'Value':dataIndx == 'do-not-install'?'DNI':dataIndx == 'vendor_part_number'?'VPN':dataIndx == 'footprint'?'Footprint':dataIndx;
          var labelObj = {
            'labelName' : displayName,
            'labelType':'existing',
            'selectedName1' : this.autoMapfieldsData['headerDataValuesBOM1']['custmerFileColumnheaderMapIndex'][dataIndx] != null ?parseInt(this.autoMapfieldsData['headerDataValuesBOM1']['custmerFileColumnheaderMapIndex'][dataIndx]):'',
            'selectedName2' : this.autoMapfieldsData['headerDataValuesBOM1']['custmerFileColumnheaderMapIndex'][dataIndx] != null ?parseInt(this.autoMapfieldsData['headerDataValuesBOM1']['custmerFileColumnheaderMapIndex'][dataIndx]):'',
            'mainlabelData': this.autoMapfieldsData['headerDataValuesBOM1']['custmerFileColumnheaderMapIndex'][dataIndx] != null ?parseInt(this.autoMapfieldsData['headerDataValuesBOM1']['custmerFileColumnheaderMapIndex'][dataIndx]):'',
          }
          
          // if(dropDownDataObj['labelValue'] != '' && dropDownDataObj['labelValue'] != null){
          //   this.mainRowArrayObj['bomOneMapArrayData'].push(dropDownDataObj);
          // }else{
          //   labelObj.selectedName1 = '';
          //   labelObj.selectedName2 = '';
          // }
          this.mainRowArrayObj['labelsArray'].push(labelObj);
        }
        
        for(var bom1DataIndx in this.autoMapfieldsData['headerDataValuesBOM1']['rowHeaderBOMData']){
          var dropDownDataObj = {
            'labelValue' : this.autoMapfieldsData['headerDataValuesBOM1']['rowHeaderBOMData'][bom1DataIndx],
            'labelIndx' : bom1DataIndx,
            'selectedObj' : bom1DataIndx
          }
          this.mainRowArrayObj['bomOneMapArrayData'].push(dropDownDataObj);
        }
        for(var bom2DataIndx in this.autoMapfieldsData['headerDataValuesBOM2']['rowHeaderBOMData']){
          var dropDownDataObjTwo = {
            'labelValue' : this.autoMapfieldsData['headerDataValuesBOM2']['rowHeaderBOMData'][bom2DataIndx],
            'labelIndx' : bom2DataIndx,
            'selectedObj' : bom2DataIndx
          }
          this.mainRowArrayObj['bomTwoMapArrayData'].push(dropDownDataObjTwo);
        }
        // for(var bowTwoIndx in this.autoMapfieldsData['headerDataValuesBOM2']['custmerFileColumnheaderMap']){
        //   var dropDownDataObjTwo = {
        //     'labelValue' : this.autoMapfieldsData['headerDataValuesBOM2']['custmerFileColumnheaderMap'][bowTwoIndx],
        //     'labelIndx' : this.autoMapfieldsData['headerDataValuesBOM2']['custmerFileColumnheaderMapIndex'][bowTwoIndx],
        //     'selectedObj' : bowTwoIndx
        //   }
        //   if(dropDownDataObjTwo['labelValue'] != '' && dropDownDataObjTwo['labelValue'] != null){
        //     this.mainRowArrayObj['bomTwoMapArrayData'].push(dropDownDataObjTwo);
        //   }
        // }
      },100)
  }

  cancelCompare(){
      this.modelController.dismiss();
  }

  addMoreRows(){
    if(this.addedRowsCount <6){
      var newLabelObj = {
        'labelName':'',
        'labelType':'new',
        'mainlabelData':'',
        'selectedName1':'',
        'selectedName2':''
      }
      this.mainRowArrayObj['labelsArray'].push(newLabelObj);
      this.addedRowsCount++;
    }  
  }

  removeRows(indx){
    this.addedRowsCount--;
    this.mainRowArrayObj['labelsArray'].splice(indx,1);
  }

  changeColumnData(labelIndx,modelData,selectedObjType){
    // if(this.mainRowArrayObj['labelsArray'][labelIndx]['selectedName1'] && this.mainRowArrayObj['labelsArray'][labelIndx]['selectedName2']){
    //   if(this.mainRowArrayObj['labelsArray'][labelIndx]['selectedName1'] == this.mainRowArrayObj['labelsArray'][labelIndx]['selectedName2']){
    //     this.mainRowArrayObj['labelsArray'][labelIndx]['mainlabelData'] = modelData;
    //   }else{
    //     this.apiservice.alertFn('Please select the same data on BOM1 and BOM2','');
    //     this.mainRowArrayObj['labelsArray'][labelIndx]['selectedName2'] = '';
    //     this.mainRowArrayObj['labelsArray'][labelIndx]['selectedName1'] = '';
    //   }
    // }
  }

  async bomColumnMapProceed(){
    var errorMsg = '';
    for(var checkIndx in this.mainRowArrayObj['labelsArray']){
      if(this.mainRowArrayObj['labelsArray'][checkIndx]['labelName'] == ''){
        errorMsg = 'Please select label name';
        break;
      }
      this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName1'] = this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName1'] +'';
      this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName2'] = this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName2'] +'';
      if(this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName1'] == ''){
        errorMsg = 'Please fill the ' + this.mainRowArrayObj['labelsArray'][checkIndx]['labelName'] + ' field in BOM1';
        break;
      }else if(this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName2'] == ''){
        errorMsg = 'Please fill the ' + this.mainRowArrayObj['labelsArray'][checkIndx]['labelName'] + ' field in BOM2';
        break;
      }
      // if(this.mainRowArrayObj['labelsArray'][checkIndx]['labelType'] != 'new' && this.mainRowArrayObj['labelsArray'][checkIndx]['labelName'] == 'Item Number'){
      //   if(this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName1'] == ''){
      //     errorMsg = 'Please fill the Item Number field in BOM1';
      //     break;
      //   }else if(this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName2'] == ''){
      //     errorMsg = 'Please Fill the Item Number field in BOM2';
      //     break;
      //   }
      // }else if(this.mainRowArrayObj['labelsArray'][checkIndx]['labelType'] != 'new' && this.mainRowArrayObj['labelsArray'][checkIndx]['labelName'] == 'Quantity'){
      //   if(this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName1'] == ''){
      //     errorMsg = 'Please Fill the Quantity field in BOM1';
      //     break;
      //   }else if(this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName2'] == ''){
      //     errorMsg = 'Please Fill the Quantity field in BOM2';
      //     break;
      //   }
      // }else if(this.mainRowArrayObj['labelsArray'][checkIndx]['labelType'] != 'new' && this.mainRowArrayObj['labelsArray'][checkIndx]['labelName'] == 'Reference designator'){
      //   if(this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName1'] == ''){
      //     errorMsg = 'Please Fill the Reference Designator field in BOM1';
      //     break;
      //   }else if(this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName2'] == ''){
      //     errorMsg = 'Please Fill the Reference Designator field in BOM2';
      //     break;
      //   }
      // }else if(this.mainRowArrayObj['labelsArray'][checkIndx]['labelType'] != 'new' && this.mainRowArrayObj['labelsArray'][checkIndx]['labelName'] == 'MPN'){
      //   if(this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName1'] == ''){
      //     errorMsg = 'Please Fill the MPN field in BOM1';
      //     break;
      //   }else if(this.mainRowArrayObj['labelsArray'][checkIndx]['selectedName2'] == ''){
      //     errorMsg = 'Please Fill the MPN field in BOM2';
      //     break;
      //   }
      // }
    }
    if(errorMsg){
      this.apiservice.alertFn(errorMsg,'');
      return false;
    }
    // var finalBom1DataObj = {};
    var mapObj1 = {}
    // var finalBom2DataObj = {};
    var mapObj2 = {}
    for(var finalBom1Indx in this.mainRowArrayObj['labelsArray']){
      var nameChange = this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'item number'? 'item_num': this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'quantity' || this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'qty' ? 'quantity' : this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'reference designator' || this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'reference_designator' ? 'reference_designators' : this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'mpn' || this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'manufacturer part number' ? 'manufacturer_part_number' :  this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'manufacturer' ? 'manufacturer' : this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'description' || this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'part description' ? 'description' : this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'value' ? 'value' : this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'do-not-install' || this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'do_not_install' || this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'dni' ? 'do-not-install' : this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'vendor_part_number' || this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'vendor-part-number' || this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'vpn' || this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'vendor part number' ? 'vendor_part_number' : this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase() == 'footprint' ? 'footprint':this.mainRowArrayObj['labelsArray'][finalBom1Indx]['labelName'].toLowerCase()
      mapObj1[nameChange] = this.mainRowArrayObj['labelsArray'][finalBom1Indx]['selectedName1'] ? parseInt(this.mainRowArrayObj['labelsArray'][finalBom1Indx]['selectedName1']):null
      mapObj2[nameChange] = this.mainRowArrayObj['labelsArray'][finalBom1Indx]['selectedName2'] ? parseInt(this.mainRowArrayObj['labelsArray'][finalBom1Indx]['selectedName2']):null
    }
    // for(var finalIndx in this.mainRowArrayObj['labelsArray']){
    //   if(this.mainRowArrayObj['labelsArray'][finalIndx]['selectedName1']){
    //     for(var mapObj1Indx in this.autoMapfieldsData['headerDataValuesBOM1']['custmerFileColumnheaderMap']){
    //       if(this.mainRowArrayObj['labelsArray'][finalIndx]['mainlabelData'] == mapObj1Indx){
    //         mapObj1[this.mainRowArrayObj['labelsArray'][finalIndx]['mainlabelData']] = this.autoMapfieldsData['headerDataValuesBOM1']['custmerFileColumnheaderMap'][mapObj1Indx]
    //       }
    //     }
    //   }else{
    //     if(this.mainRowArrayObj['labelsArray'][finalIndx]['mainlabelData'] && this.mainRowArrayObj['labelsArray'][finalIndx]['labelType'] != 'new'){
    //       mapObj1[this.mainRowArrayObj['labelsArray'][finalIndx]['mainlabelData']] = null;
    //     }
    //   }
    // }
    // for(var finalIndx in this.mainRowArrayObj['labelsArray']){
    //   if(this.mainRowArrayObj['labelsArray'][finalIndx]['selectedName2']){
    //       for(var mapObj1Indx in this.autoMapfieldsData['headerDataValuesBOM2']['custmerFileColumnheaderMap']){
    //         if(this.mainRowArrayObj['labelsArray'][finalIndx]['mainlabelData'] == mapObj1Indx){
    //           mapObj2[this.mainRowArrayObj['labelsArray'][finalIndx]['mainlabelData']] = this.autoMapfieldsData['headerDataValuesBOM2']['custmerFileColumnheaderMap'][mapObj1Indx]
    //         }
    //       }
    //   }else{
    //     if(this.mainRowArrayObj['labelsArray'][finalIndx]['mainlabelData'] &&  this.mainRowArrayObj['labelsArray'][finalIndx]['labelType'] != 'new'){
    //         mapObj2[this.mainRowArrayObj['labelsArray'][finalIndx]['mainlabelData']] = null;
    //     }
    //   }
    // }
    // var headerMapObjBom1 = {}
    // for(var headderMapBom1Indx in mapObj1){
    //   headerMapObjBom1[headderMapBom1Indx] = mapObj1[headderMapBom1Indx] && mapObj1[headderMapBom1Indx] != null ? parseInt(mapObj1[headderMapBom1Indx].split(':')[0].split(' ')[1]):mapObj1[headderMapBom1Indx] == null?null : '';
    // }
    // var headerMapObjBom2 = {}
    // for(var headderMapBom2Indx in mapObj2){
    //   headerMapObjBom2[headderMapBom2Indx] = mapObj2[headderMapBom2Indx] && mapObj2[headderMapBom2Indx] != null ? parseInt(mapObj2[headderMapBom2Indx].split(':')[0].split(' ')[1]):mapObj2[headderMapBom2Indx] == null?null : '';
    // }
    console.log(mapObj1) 
    console.log(mapObj2)
    this.autoMapfieldsData['headerDataValuesBOM1']['custmerFileColumnheaderMapIndex'] = mapObj1 
    this.autoMapfieldsData['headerDataValuesBOM2']['custmerFileColumnheaderMapIndex'] = mapObj2 
    this.autoMapfieldsData['customerDetails'] = {};
    // this.autoMapfieldsData['customerDetails']['email'] = this.userMail
    this.autoMapfieldsData['customerDetails']['email'] = ''
    console.log(this.autoMapfieldsData);
    this.loadingView = await this.loadingController.create({
      message: 'Please wait...'
    });
    await this.loadingView.present();
    this.apiservice.updateColumnData(this.autoMapfieldsData).subscribe((resData: any)=>{
      this.loadingView.dismiss();
      this.modelController.dismiss(resData);
      console.log(resData)
    },err=>{
      console.log(err)
      this.loadingView.dismiss();
    });
  }
}
